import type { FilterOn, MembershipFilterOn } from "helpers/filters/filter-ons"

export const TAG_STANDALONE_ADVICE_TOOLTIP = "Tags only exist on your portfolio. In Active, use Standalone to filter by tag."
export const POSITION_ATTRIBUTES_STANDALONE_ADVICE_TOOLTIP = "Position set attributes only exist on your portfolio. In Active, use Standalone to filter by position set attribute."

const STANDALONE_ADVICE_TOOLTIPS = {
  tag: TAG_STANDALONE_ADVICE_TOOLTIP,
  positionAttributes: POSITION_ATTRIBUTES_STANDALONE_ADVICE_TOOLTIP,
}

function isMembershipFilterOn(filterOn: FilterOn): filterOn is MembershipFilterOn {
  return filterOn.type === "tag" || filterOn.type === "positionAttributes"
}

interface UnsupportedItem {
  isUnsupported: boolean
  isUnsupportedByNormalization: boolean
  isUnsupportedUnderContribution: boolean
  isUnsupportedByMultipleInstruments: boolean
  tooltip: string | false
}

function computeItemForPendingNormalization<Item extends UnsupportedItem>(item: Item, adviceTooltip: string, isStandalonePending: boolean): Item {
  if (!item.isUnsupportedUnderContribution || item.isUnsupportedByMultipleInstruments) {
    return item
  }
  return isStandalonePending
    ? { ...item, isUnsupported: false, isUnsupportedByNormalization: false }
    : { ...item, isUnsupported: true, isUnsupportedByNormalization: true, tooltip: adviceTooltip }
}

export function computePendingFilterOns(filterOns: FilterOn[], isStandalonePending: boolean): FilterOn[] {
  return filterOns.map((filterOn) => {
    if (!isMembershipFilterOn(filterOn)) {
      return filterOn
    }

    const adviceTooltip = STANDALONE_ADVICE_TOOLTIPS[filterOn.type]
    const options = filterOn.options.map((option) => computeItemForPendingNormalization(option, adviceTooltip, isStandalonePending))
    return { ...computeItemForPendingNormalization(filterOn, adviceTooltip, isStandalonePending), options }
  })
}
